export const normalizeCategoryName = (value: any): string => {
    if (typeof value !== 'string') return '';
    return value.trim().normalize('NFKC');
};

export const splitCategoryPath = (categoryPath: any): string[] => {
    if (typeof categoryPath !== 'string') return [];
    return categoryPath
        .split(/[\/／]/)
        .map(normalizeCategoryName)
        .filter((name) => name.length > 0);
};

export const getCategoryParentId = (category: any): string | null => {
    const parentId = category?.parentId ?? category?.parent_id ?? category?.parent?.id ?? null;
    return parentId === null || parentId === undefined ? null : String(parentId);
};

export const hasMatchingStructurePartCategoryPath = (categoryNames: any[], categories: any[]): boolean => {
    const normalizedPath = (Array.isArray(categoryNames) ? categoryNames : [])
        .map(normalizeCategoryName)
        .filter((name) => name.length > 0);
    if (normalizedPath.length === 0) return false;

    let candidateIds = new Set(
        categories
            .filter((category: any) => (
                normalizeCategoryName(category?.name) === normalizedPath[0] &&
                getCategoryParentId(category) === null
            ))
            .map((category: any) => String(category.id))
    );

    if (candidateIds.size === 0) return false;

    for (let i = 1; i < normalizedPath.length; i++) {
        const targetName = normalizedPath[i];
        candidateIds = new Set(
            categories
                .filter((category: any) => (
                    normalizeCategoryName(category?.name) === targetName &&
                    candidateIds.has(getCategoryParentId(category) || '')
                ))
                .map((category: any) => String(category.id))
        );
        if (candidateIds.size === 0) return false;
    }

    return true;
};

